import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { SupplyWalkSingleViewerComponent } from "./viewer_component";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { paramsToTransformArgs } from "./params_to_transform_args";

export const SupplyWalkSingleContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "supply_walk_parallelized",
        folder: "outputs",
        title: "Supply Walk Single (Beta)",
        dateHierarchyColumnFilter: {
          week: "week",
          month: "month",
          day: "day",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {},
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.PostFilterByHardcodedColumns,
        ],
        hardcodedColumns: [
          {
            name: "has_near_term_purchase",
            caption: "Has Near Term Purchase",
            unique_values: ["true", "false"],
          },
          {
            name: "has_near_term_arrivals",
            caption: "Has Near Term Arrivals",
            unique_values: ["true", "false"],
          },
          {
            name: "has_near_term_stock_risk",
            caption: "Has Near Term Stock Risk",
            unique_values: ["true", "false"],
          },
        ],
        paramsToTransformArgs: paramsToTransformArgs,
      }}
      defaultConfig={defaultConfig}
      viewerComponent={SupplyWalkSingleViewerComponent}
    />
  );
};
